import { render, staticRenderFns } from "./RuleGroupSettings.vue?vue&type=template&id=400c5288"
import script from "./RuleGroupSettings.vue?vue&type=script&lang=js"
export * from "./RuleGroupSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports